module.exports = __webpack_public_path__ + "img/inu_gallery17.0e514646.jpg";